/** zh-CN catalogue `preview` (W3-09; English: src/features/preview/preview.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'preview',
  locale: 'zh-CN',
  messages: {
    panelTitle: '预览',
    toolbarLabel: '预览工具',
    emptyTitle: '没有打开的谱面',
    emptyBody: '打开或新建一张谱面，即可在这里看到与 Phira 完全一致的播放效果。',
    elsewhereTheater: '预览正在影院模式中显示。',
    elsewhereTestPlay: '预览正在试玩中显示。',
    screenMenu: '屏幕比例',
    screenButton: '屏幕比例：{screen}',
    screenChart: '谱面（{aspect}）',
    screenFill: '填满面板',
    screenAs: '模拟 {shape}',
    screenOptionChart: '谱面的宽高比',
    screenOptionFill: '填满面板',
    screenOptionAs: '模拟 {shape} 屏幕',
    screenOpt169: '模拟 16:9 屏幕',
    screenOpt43: '模拟 4:3 屏幕',
    screenOpt32: '模拟 3:2 屏幕',
    screenOpt195: '模拟 19.5:9 手机',
    screenOpt219: '模拟 21:9 屏幕',
    modeLabel: '预览模式',
    modeClean: '纯净',
    modeEdit: '编辑',
    moreMenu: '更多预览选项',
    snapMenu: '操纵器吸附',
    snapGrid: '吸附到网格（{size} px）',
    snapGridSize: '网格大小',
    snapGridSizeOption: '{size} px',
    snapCentre: '吸附到屏幕中心',
    snapEdges: '吸附到屏幕边缘',
    snapAnchors: '吸附到其他判定线',
    snapReset: '重置吸附',
    zoomPercent: '{percent}%',
    testMenu: '试玩选项',
    testAutoplay: '试玩：观看（自动播放）',
    testJudged: '试玩：亲自游玩（判定）',
    fromPlayhead: '从播放头前 2 拍开始',
    fromStart: '从谱面开头开始',
    argFrom: '开始试玩',
    cancel: '取消',
    percentValue: '{value}%',
    cmdTheater: '影院模式',
    cmdTestPlay: '试玩',
    cmdToggleMode: '在纯净和编辑之间切换预览',
    cmdHud: '显示游戏内 HUD',
    cmdLabels: '显示判定线标签',
    cmdSafeArea: '安全区参考线',
    cmdGhosts: '显示隐藏的音符',
    cmdInvisibleLines: '显示不可见的判定线',
    cmdGizmo: '显示操纵器',
    cmdAutoKey: '自动关键帧',
    cmdSampleMode: '取样模式',
    cmdLaneLink: '关联轨道与预览（悬停标记）',
    cmdScreen: '预览屏幕比例',
    cmdPhiraSettings: 'Phira 玩家设置',
    cmdReadout: '判定线读数',
    cmdResetView: '重置预览缩放',
    cmdZoomIn: '放大预览',
    cmdZoomOut: '缩小预览',
    cmdJudged: '带判定的试玩',
    cmdForceAspect: '所有玩家使用相同的宽高比（forceAspectRatio）',
    cmdAddLineHere: '在此处添加判定线',
    cmdMakeActive: '设为当前判定线',
    cmdSetParent: '设置父线…',
    cmdClearParent: '移除父线',
    cmdSelectLineNotes: '选中其音符',
    cmdClearFilters: '显示全部（清除预览筛选）',
    reasonNoProject: '请先打开一张谱面。',
    reasonEditMode: '请将预览切换到编辑模式后再使用。',
    effectsApproximateList: '当前显示：{names}。',
    effectsNotPreviewed: '特效未预览',
    effectsNotPreviewedList: '绘制时未包含这些特效：{names}。',
    reasonNoLineHere: '这里没有判定线。',
    reasonNoParent: '此判定线没有父线。',
    reasonNoNotes: '此判定线没有音符。',
    toastSelectedNotes: '{count, plural, other {已选中 # 个音符}}',
    safeAreaNone: '无安全区参考线',
    safeAreaOption: '{area} 安全区',
    safeAreaLabel: '{aspect} 安全区',
    ghostCover: '已隐藏：音符位于其判定线下方，且“遮罩（隐藏线下音符）”已开启（RPE isCover）。',
    ghostNegativeLineAlpha: '已隐藏：判定线不透明度低于 0，因此 Phira 隐藏其音符（它们仍会被判定）。',
    ghostCulled: '已隐藏：被 Phira 的激进剔除（玩家设置，默认开启）剔除：它会在屏幕边缘之外第一个此速度的音符处停止。',
    ghostUiMoverLine: '已隐藏：UI 绑定线上的音符永远不会被绘制。',
    ghostBeforeVisibleTime: '已隐藏：在其出现时间（可见时间）之前。',
    ghostOffscreen: '此刻在屏幕外。',
    ghostFiltered: '被预览筛选隐藏（隐藏或独显的判定线）。',
    invisibleAlpha: '{label}：不透明度为 0 或更低，Phira 不会绘制任何内容。',
    invisibleScale: '{label}：尺寸为 0，Phira 不会绘制任何内容。',
    invisibleEmptyText: '{label}：文字为空，Phira 不会绘制任何内容。',
    invisiblePaintCleared: '{label}：画笔为 0 或更小，因此其绘制内容被清除。',
    invisibleUiMover: '{label}：UI 绑定线；它移动{element} HUD 元素，而不绘制自身。',
    hudMoves: '移动：{element}',
    hudPause: '暂停按钮',
    hudComboNumber: '连击数',
    hudCombo: 'COMBO 文字',
    hudScore: '分数',
    hudBar: '进度条',
    hudName: '曲名',
    hudLevel: '难度等级',
    laneX: 'X {x}',
    offscreen: '{label}（屏幕外）',
    sampleStart: '起点',
    sampleEnd: '终点',
    sampleStartHelp: '拖动以修改选中区段的起点。',
    sampleEndHelp: '拖动以修改选中区段的终点。',
    sampleHoldEnd: '此区段为钩定：其终点跟随起点。',
    lineLocked: '此判定线已锁定（判定线面板）。请解锁后再编辑。',
    parentPickHint: '单击新的父线，或单击空白处表示没有父线。',
    parentPromptTitle: '设置父线',
    parentKeepPlace: '保持其在屏幕上的位置',
    parentKeepPlaceHelp: '其位置会换算到父线的坐标系中，因此现在不会移动。',
    parentKeepNumbers: '保持其数值',
    parentKeepNumbersHelp: '其数值保持不变（RPE 的行为）；它会随父线移动。',
    propX: 'X',
    propY: 'Y',
    propRotate: '旋转',
    propOpacity: '不透明度',
    propLength: '长度',
    propWidth: '宽度',
    propHeight: '高度',
    propSpeed: '速度',
    propOther: '数值',
    ruleKeyNew: '{axis}：在 {beat} 新建关键帧',
    ruleKeyUpdate: '{axis}：更新 {beat} 处的关键帧',
    ruleWhole: '{axis}：整张谱面',
    ruleWholeNew: '{axis}：整张谱面（新轨道）',
    ruleCreateAt: '{axis}：新轨道，关键帧位于 {beat}（在此之前保持原样）',
    ruleOffset: '{axis}：{count, plural, other {移动 # 个关键帧}}',
    ruleOffsetSelected: '{axis}：{count, plural, other {移动 # 个选中的关键帧}}',
    ruleTooltip: '当前拖动：{rules}',
    hintLock: '锁定为单一轴',
    hint15: '以 15 度为步长',
    hintWidthOnly: '仅宽度',
    hintOffset: '平移整个运动',
    hintNoSnap: '不吸附',
    hintCancel: '取消',
    summaryAxis: '{axis} {value}',
    summaryRotate: '{value} 度',
    summaryScale: '{value}%',
    txnMove: '移动判定线',
    txnRotate: '旋转判定线',
    txnLength: '修改判定线长度',
    txnSize: '调整判定线尺寸',
    txnOpacity: '修改判定线不透明度',
    txnOffset: '平移运动',
    txnSample: '移动区段端点',
    txnAddLine: '添加判定线',
    txnSetParent: '设置父线',
    txnClearParent: '移除父线',
    txnForceAspect: '修改 forceAspectRatio',
    readoutLabel: '播放头处的当前判定线',
    readoutNoLine: '没有当前判定线：请在预览或判定线面板中单击一条判定线。',
    readoutDeg: '{value} 度',
    readoutAbsent: '未设置',
    opacitySlider: '不透明度',
    phiraTitle: 'Phira 玩家设置',
    phiraNote: '仅用于预览：使用这些设置的玩家看到的效果。永远不会写入谱面。',
    phiraAspect: '宽高比（aspect_ratio）',
    phiraAspectChart: '与谱面相同（{aspect}）',
    phiraNoteScale: '音符大小（note_scale）',
    phiraNoteScaleValue: '{value}x',
    phiraDoubleHint: '高亮多押（double hint）',
    phiraParticles: '粒子',
    phiraAggressive: '激进音符剔除',
    phiraStrictAutoplay: '自动播放的打击颜色与 Phira 一致（忽略 tintHitEffects）',
    phiraMsaa: '抗锯齿（MSAA）',
    phiraApFc: 'AP/FC 判定线颜色指示',
    phiraDimOverride: '覆盖背景暗度（谱面：{value}%）',
    phiraDim: '背景暗度',
    phiraReset: '恢复 Phira 默认值',
    bannerDiffers: '预览与导出不同：{parts}。',
    bannerHidden: '已隐藏 {count, plural, other {# 条判定线}}',
    bannerSolo: '已独显 {count, plural, other {# 条判定线}}',
    bannerMuted: '已静音 {count, plural, other {# 个层级}}',
    bannerDim: '其他判定线已调暗',
    bannerShowAll: '显示全部',
    listJoin: '{a}、{b}',
    theaterLabel: '影院模式',
    theaterExit: '返回编辑器',
    theaterHintPlay: '播放和暂停',
    theaterHintExit: '返回编辑器，继续播放',
    testPlayLabel: '试玩',
    pauseButton: '暂停（Esc）',
    pauseTitle: '已暂停',
    resume: '继续',
    restart: '重新开始',
    backHere: '在此处返回编辑器',
    backStart: '返回开始的位置',
    modeTitle: '模式',
    modeAutoplay: '自动播放',
    modeJudged: '游玩（判定）',
    rate: '速率',
    rateOption: '{rate}x',
    judgedHelp: '按任意字母键或鼠标左键来 Tap。按住按键可接 Drag 和 Hold。Flick：按住时移动鼠标，或按空格。Esc 暂停。',
    autoplayHelp: '自动播放：谱面会像在 Phira 中一样播放。按 Esc 或空格暂停。',
    gradeAnnounce: '{grade, select, perfect {Perfect} good {Good} bad {Bad} other {Miss}}',
    finishedTitle: '已结束',
    finishedAutoplay: '自动播放已到达曲目末尾。',
    resultsTitle: '结果',
    resultsNoNotes: '没有演奏任何音符。',
    accuracy: '准确率',
    accuracyValue: '{value}%',
    score: '分数',
    maxCombo: '最大连击',
    gradePerfect: 'Perfect',
    gradeGood: 'Good',
    gradeBad: 'Bad',
    gradeMiss: 'Miss',
    earlyLate: '偏早 / 偏晚',
    earlyLateValue: '{early} / {late}',
    meanOffset: '平均时间偏差',
    meanValue: '{dir, select, early {早 {ms} 毫秒} late {晚 {ms} 毫秒} other {准时}}',
    pending: '未到达',
    histogramLabel: '偏早和偏晚的击打；激活一根柱子即可跳到对应的音符',
    histogramBar: '{count, plural, other {# 个音符}}在 {from} 到 {to} 毫秒之间被击打。激活即可在编辑器中选中它们。',
    histogramEarly: '{ms} 毫秒（偏早）',
    histogramLate: '+{ms} 毫秒（偏晚）',
    timingHint:
      '{dir, select, early {你的击打平均早了 {ms} 毫秒。} other {你的击打平均晚了 {ms} 毫秒。}}如果每次都这样，请校准音频延迟，或在“曲目与时间”中检查偏移。谱面偏移永远不会被自动更改。',
    openTiming: '打开“曲目与时间”',
    calibrate: '校准延迟',
    setScreen: '预览屏幕比例',
    setScreenDesc: '预览模拟的屏幕。使用其他屏幕的玩家会像在 Phira 中一样看到加黑边或被压缩的谱面。',
    setReadout: '在预览下方显示判定线读数',
    setReadoutDesc: '播放头处当前判定线的位置、旋转、不透明度和速度（Shift+I）。',
    setTestMode: '试玩模式',
    setTestModeDesc: '自动播放会像 Phira 一样播放谱面；带判定的游玩可让你用键盘和鼠标亲自演奏。',
    setLaneLinkDesc: '悬停在音符轨道上时，会在预览的判定线上标出对应位置，悬停的音符会在两处同时描边。',
    setLeadIn: '试玩预备（播放头之前的拍数）',
    setLeadInDesc: '从播放头开始试玩时，会提前这么多拍开始。',
    helpPreviewTitle: '预览',
    helpPreviewBody:
      '预览是谱面在播放头处真实的 Phira 渲染效果。**纯净**只显示玩家看到的内容；**编辑**会添加判定线标签、不可见判定线和隐藏音符的轮廓，以及操纵器。单击音符可选中它，单击判定线可将其设为当前判定线（再次单击可在重叠的判定线之间循环），右键单击可执行判定线操作。Ctrl+滚轮缩放，中键拖动平移。',
    helpGizmoTitle: '用操纵器移动判定线',
    helpGizmoBody:
      '拖动中心可移动当前判定线，拖动圆环可旋转，拖动两端的控制柄可修改长度或尺寸。只有一个关键帧的属性会在整张谱面中改变；有动画的属性会在播放头处得到一个关键帧（位置作为一对计算）。在完整级别下，**自动关键帧**会让每次拖动都写入关键帧。圆环以整度旋转。按住 Shift 锁定一个轴（圆环以 15 度为步长），按住 Ctrl 平移整个运动，按住 Alt 不吸附地自由移动或旋转；Esc 取消。',
    helpTestPlayTitle: '试玩',
    helpTestPlayBody:
      'F5 从播放头前 2 拍开始播放，Shift+F5 从开头开始。在带判定的游玩中，任意字母键或鼠标左键可 Tap，按住按键可接 Drag 和 Hold，空格或鼠标滑动可 Flick。结果会显示你的准确率，以及击打偏早还是偏晚。',
    labelsHidden: '{count, plural, other {另有 # 个标签已隐藏（悬停在判定线上即可查看）}}',
    moreTitle: '预览工具',
    propOpacityShort: '不透明',
    propRotateShort: '旋转',
    propSpeedShort: '速度',
    readoutCross: '（{sec} 秒穿过屏幕）',
    readoutNeverCrosses: '（永不穿过屏幕）',
    testChooseBody: '随时可以在“试玩”按钮旁的菜单或暂停菜单中切换。',
    testChoosePlay: '亲自游玩（判定）',
    testChoosePlayDesc: '用任意字母键或鼠标 Tap，用空格 Flick。会显示你的准确率以及偏早 / 偏晚的时间。',
    testChooseTitle: '你想怎样测试谱面？',
    testChooseWatch: '观看（自动播放）',
    testChooseWatchDesc: '谱面会像 Phira 的自动播放一样自行播放。适合检查视觉效果。',
    testPlayShort: '游玩',
    testPlayWide: '试玩：游玩',
    testWatchShort: '观看',
    testWatchWide: '试玩：观看',
    theaterControls: '影院模式控制',
    theaterHintStop: '停止并返回编辑器',
  },
};

export default catalog;
